import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import { phases } from '../../data/phases';
import './PhaseFlow.css';

/**
 * Left-to-right phase-flow diagram, shared by HowItWorks and the landing page
 * (PRD-171B WP8).
 *
 * - linkBase="" (default, HowItWorks): same-page `#phase-NN` anchors rendered
 *   via <Reveal as="a"> so the staggered entrance is preserved. The browser
 *   handles same-page fragment scrolling natively.
 * - linkBase="/how-it-works" (landing): cross-page React Router <Link> — a raw
 *   <a> would full-page-reload the SPA. React Router does NOT scroll to a hash
 *   natively (A10), so HowItWorks carries a hash-scroll useEffect that lands the
 *   visitor on the target phase.
 *
 * A page that renders this alongside <PublicHeader> then has two <nav>s; this one
 * is labelled distinctly ("The six assessment phases") to keep them distinguishable.
 */
function PhaseFlow({ linkBase = '', ariaLabel = 'The six assessment phases' }) {
  return (
    <nav className="phase-flow" aria-label={ariaLabel}>
      <ol className="phase-flow-track">
        {phases.map((p, i) => (
          <li key={p.number} className="phase-flow-item">
            {linkBase ? (
              <Link to={`${linkBase}#phase-${p.number}`} className="phase-flow-box">
                <span className="phase-flow-num">{p.number}</span>
                <span className="phase-flow-title">{p.title}</span>
              </Link>
            ) : (
              <Reveal as="a" href={`#phase-${p.number}`} className="phase-flow-box" delay={i * 240}>
                <span className="phase-flow-num">{p.number}</span>
                <span className="phase-flow-title">{p.title}</span>
              </Reveal>
            )}
            {i < phases.length - 1 && (
              <span className="phase-flow-arrow" aria-hidden="true">&rarr;</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default PhaseFlow;
